module.exports = __webpack_public_path__ + "static/media/visa.44d75d95.svg";